import AddIcon from "@mui/icons-material/Add";
import FilterListIcon from "@mui/icons-material/FilterList";
import GroupsIcon from "@mui/icons-material/Groups";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import NavigateBeforeOutlinedIcon from "@mui/icons-material/NavigateBeforeOutlined";
import NavigateNextOutlinedIcon from "@mui/icons-material/NavigateNextOutlined";
import PersonIcon from "@mui/icons-material/Person";
import { Grid, Typography } from "@mui/material";
import { useState } from "react";
import CustomButton from "../../../components/CustomButton";
import CustomCheckbox from "../../../components/CustomCheckbox";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../components/CustomTextField";
import Select from "../../../components/Select/Select";
import ReportTable from "../Reports/ReportTable";
import "./WhiteboardTab.css";

const filterApptTypeOptions = [
  { name: "All selected", value: "All selected" },
  { name: "Outpatient", value: "Outpatient" },
  { name: "Inpatient", value: "Inpatient" },
  { name: "Virtual", value: "Virtual" },
  { name: "Home Visit", value: "Home Visit" },
];

const filterTaskTypeOptions = [
  { name: "All selected", value: "All selected" },
  { name: "Medication", value: "Medication" },
  { name: "Fluid Therapy", value: "Fluid Therapy" },
  { name: "Monitoring Check", value: "Monitoring Check" },
  { name: "Diet", value: "Diet" },
  { name: "Procedure", value: "Procedure" },
  { name: "Other", value: "Other" },
];

const filterStatusOptions = [
  { name: "All selected", value: "All selected" },
  { name: "Pending", value: "Pending" },
  { name: "Overdue", value: "Overdue" },
  { name: "Cancelled", value: "Cancelled" },
  { name: "Completed", value: "Completed" },
];

const filterPriorityOptions = [
  { name: "All selected", value: "All selected" },
  { name: "High", value: "High" },
  { name: "Medium", value: "Medium" },
  { name: "Low", value: "Low" },
];

const taskTypeOptions = [
  { name: "Medication", value: "Medication" },
  { name: "Fluid Therapy", value: "Fluid Therapy" },
  { name: "Monitoring Check", value: "Monitoring Check" },
  { name: "Diet", value: "Diet" },
  { name: "Procedure", value: "Procedure" },
  { name: "Other", value: "Other" },
];

const priorityOptions = [
  { name: "Low", value: "Low" },
  { name: "Medium", value: "Medium" },
  { name: "High", value: "High" },
  { name: "Urgent", value: "Urgent" },
];

const routeOptions = [
  { name: "IV", value: "IV" },
  { name: "IM", value: "IM" },
  { name: "SC", value: "SC" },
  { name: "PO", value: "PO" },
  { name: "Topical", value: "Topical" },
];

const frequencyOptions = [
  { name: "SID — Once daily", value: "SID — Once daily" },
  { name: "BID — Twice daily", value: "BID — Twice daily" },
  { name: "TID — Three times daily", value: "TID — Three times daily" },
  { name: "QID — Four times daily", value: "QID — Four times daily" },
  { name: "Q4H — Every 4 hours", value: "Q4H — Every 4 hours" },
  { name: "Q6H — Every 6 hours", value: "Q6H — Every 6 hours" },
  { name: "Q8H — Every 8 hours", value: "Q8H — Every 8 hours" },
  { name: "Q12H — Every 12 hours", value: "Q12H — Every 12 hours" },
  { name: "CRI — Continuous", value: "CRI — Continuous" },
  { name: "PRN — As needed", value: "PRN — As needed" },
  { name: "Once", value: "Once" },
];

const assignOptions = [
  { name: "Auto-assign (Recommended)", value: "auto" },
  { name: "Dr. Vivek", value: "Vivek" },
  { name: "Supervet", value: "Supervet" },
  { name: "Ranjan", value: "Ranjan" },
  { name: "Lab Tech", value: "Lab Tech" },
  { name: "Nurse 1", value: "Nurse 1" },
  { name: "Unassigned", value: "Unassigned" },
];

const durationOptions = [
  { name: "1 day", value: "1 day" },
  { name: "2 days", value: "2 days" },
  { name: "3 days", value: "3 days" },
  { name: "5 days", value: "5 days" },
  { name: "Until discontinued", value: "Until discontinued" },
];

const WhiteboardTab = () => {
  const [activeDayWeek, setActiveDayWeek] = useState("day");
  const [activeMainTab, setActiveMainTab] = useState("tasks"); // 'tasks' or 'todos'
  const [activeLayout, setActiveLayout] = useState("board"); // 'board' or 'list'
  const [activeMeTeam, setActiveMeTeam] = useState("my"); // 'my' or 'team'
  const [currentDateIndex, setCurrentDateIndex] = useState(0);

  // Modals
  const [isTaskModalOpen, setIsTaskModalOpen] = useState(false);
  const [isTodoModalOpen, setIsTodoModalOpen] = useState(false);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [patientType, setPatientType] = useState("inpatient"); // 'inpatient' or 'outpatient'

  // Filter Drawer State
  const [filterDisplayViewSection, setFilterDisplayViewSection] = useState(true);
  const [showUnassignedTasks, setShowUnassignedTasks] = useState(false);
  const [showComplianceIssues, setShowComplianceIssues] = useState(true);
  const [filterApptType, setFilterApptType] = useState("All selected");
  const [filterTaskType, setFilterTaskType] = useState("All selected");
  const [filterStatus, setFilterStatus] = useState("All selected");
  const [filterPriority, setFilterPriority] = useState("All selected");

  const handleResetFilters = () => {
    setShowUnassignedTasks(false);
    setShowComplianceIssues(true);
    setFilterApptType("All selected");
    setFilterTaskType("All selected");
    setFilterStatus("All selected");
    setFilterPriority("All selected");
  };

  const handleApplyFilters = () => {
    setIsFilterModalOpen(false);
  };

  // Multi-Task List State for Create Task Accordion Modal
  const [createTaskList, setCreateTaskList] = useState([
    {
      id: 1,
      isExpanded: true,
      type: "Medication",
      priority: "Medium",
      name: "",
      dose: "",
      route: "IV",
      frequency: "Once",
      start: new Date().toISOString().slice(0, 16),
      duration: "1 day",
      assignTo: "auto",
      notes: "",
    },
  ]);

  // Todo Form State
  const [todoForm, setTodoForm] = useState({
    title: "",
    content: "",
    priority: "Medium",
    color: "yellow",
    dueDate: "",
  });

  // Sample Sticky Notes for Personal To-Dos
  const [stickyNotes, setStickyNotes] = useState([
    {
      id: 1,
      title: "Review new treatment protocol",
      content: "Research latest guidelines for feline diabetes management.",
      priority: "High",
      color: "yellow",
      dueDate: "Tomorrow, 9:00 AM",
      done: false,
    },
    {
      id: 2,
      title: "Follow up on lab results",
      content: "Call Max's owner regarding CBC results.",
      priority: "Medium",
      color: "blue",
      dueDate: "Today, 3:00 PM",
      done: false,
    },
    {
      id: 3,
      title: "Weekly goals",
      content: "- Complete 5 consultations",
      priority: "Low",
      color: "green",
      dueDate: "Fri, Feb 16",
      done: true,
    },
  ]);

  const datesList = ["Wed, 12 Feb 2026", "Thu, 13 Feb 2026", "Fri, 14 Feb 2026"];

  const handlePrevDate = () => {
    setCurrentDateIndex((prev) => (prev > 0 ? prev - 1 : datesList.length - 1));
  };

  const handleNextDate = () => {
    setCurrentDateIndex((prev) => (prev < datesList.length - 1 ? prev + 1 : 0));
  };

  // Task Accordion Functions
  const handleOpenTaskModal = () => {
    setCreateTaskList([
      {
        id: Date.now(),
        isExpanded: true,
        type: "Medication",
        priority: "Medium",
        name: "",
        dose: "",
        route: "IV",
        frequency: "Once",
        start: new Date().toISOString().slice(0, 16),
        duration: "1 day",
        assignTo: "auto",
        notes: "",
      },
    ]);
    setIsTaskModalOpen(true);
  };

  const handleAddNewTask = () => {
    const newId = Date.now();
    setCreateTaskList((prev) => [
      ...prev.map((t) => ({ ...t, isExpanded: false })),
      {
        id: newId,
        isExpanded: true,
        type: "Medication",
        priority: "Medium",
        name: "",
        dose: "",
        route: "IV",
        frequency: "Once",
        start: new Date().toISOString().slice(0, 16),
        duration: "1 day",
        assignTo: "auto",
        notes: "",
      },
    ]);
  };

  const toggleTaskAccordion = (id) => {
    setCreateTaskList((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, isExpanded: !item.isExpanded } : item
      )
    );
  };

  const handleRemoveTask = (id) => {
    if (createTaskList.length <= 1) return;
    setCreateTaskList((prev) => prev.filter((item) => item.id !== id));
  };

  const updateTaskField = (id, field, value) => {
    setCreateTaskList((prev) =>
      prev.map((item) => (item.id === id ? { ...item, [field]: value } : item))
    );
  };

  const handleSaveAllTasks = () => {
    setIsTaskModalOpen(false);
  };

  const handleCreateTodoSubmit = () => {
    if (!todoForm.title) return;
    const newNote = {
      id: Date.now(),
      title: todoForm.title,
      content: todoForm.content,
      priority: todoForm.priority,
      color: todoForm.color,
      dueDate: todoForm.dueDate || "Today",
      done: false,
    };
    setStickyNotes([newNote, ...stickyNotes]);
    setIsTodoModalOpen(false);
  };

  // Table Data for List View
  const listColumns = ["task", "tags", "assignedTo", "dueDate", "status", "actions"];
  const listDatas = [
    {
      task: (
        <div>
          <div className="flex-row flex-ali-cen gap8">
            <span className="fs14 font-bold black-color">Review X-ray Results</span>
            <span className="app-priority-badge high">HIGH</span>
          </div>
          <div className="fs12 card-gray-color mt2">
            Review diagnostic report for Max (Case #1234)
          </div>
        </div>
      ),
      tags: (
        <div className="wb-card-tags">
          <span className="wb-card-tag monitoring">Monitoring</span>
          <span className="wb-card-tag outpatient">Outpatient</span>
        </div>
      ),
      assignedTo: (
        <div className="flex-row flex-ali-cen gap8">
          <div className="app-avatar-circle" style={{ width: 28, height: 28, fontSize: 11 }}>VK</div>
          <span className="fs13 font-semibold black-color">Vivek</span>
        </div>
      ),
      dueDate: <span className="red-color font-semibold fs13">2 hours ago</span>,
      status: <span className="app-status-badge rejected">Overdue</span>,
      actions: (
        <div className="flex-row gap6">
          <CustomButton text="View" smallBtn whiteBtn onClick={() => {}} />
          <CustomButton text="Assign" smallBtn whiteBtn onClick={() => {}} />
        </div>
      ),
    },
    {
      task: (
        <div>
          <div className="flex-row flex-ali-cen gap8">
            <span className="fs14 font-bold black-color">Compliance Issue ⚠️</span>
            <span className="app-priority-badge urgent">URGENT</span>
          </div>
          <div className="fs12 card-gray-color mt2">
            Medication dosage discrepancy detected
          </div>
        </div>
      ),
      tags: (
        <div className="wb-card-tags">
          <span className="wb-card-tag">Other</span>
          <span className="wb-card-tag inpatient">Inpatient</span>
          <span className="wb-card-tag plan-source">📋 Plan</span>
        </div>
      ),
      assignedTo: (
        <div className="flex-row flex-ali-cen gap8">
          <div className="app-avatar-circle" style={{ width: 28, height: 28, fontSize: 11, backgroundColor: "#8b5cf6" }}>AW</div>
          <span className="fs13 font-semibold black-color">Admin</span>
        </div>
      ),
      dueDate: <span className="red-color font-semibold fs13">Now</span>,
      status: <span className="app-status-badge rejected">Overdue</span>,
      actions: (
        <div className="flex-row gap6">
          <CustomButton text="View" smallBtn whiteBtn onClick={() => {}} />
          <CustomButton text="Resolve" smallBtn whiteBtn onClick={() => {}} />
        </div>
      ),
    },
    {
      task: (
        <div>
          <div className="flex-row flex-ali-cen gap8">
            <span className="fs14 font-bold black-color">Review Diagnostic Report</span>
            <span className="wb-pending-badge">Pending Review</span>
            <span className="app-priority-badge urgent">URGENT</span>
          </div>
          <div className="fs12 card-gray-color mt2">
            Review diagnostic report for inpatient case
          </div>
        </div>
      ),
      tags: (
        <div className="wb-card-tags">
          <span className="wb-card-tag">Other</span>
          <span className="wb-card-tag inpatient">Inpatient</span>
          <span className="wb-card-tag plan-source">📋 Plan</span>
        </div>
      ),
      assignedTo: (
        <div className="flex-row flex-ali-cen gap8">
          <div className="app-avatar-circle" style={{ width: 28, height: 28, fontSize: 11 }}>VK</div>
          <span className="fs13 font-semibold black-color">Vivek</span>
        </div>
      ),
      dueDate: <span className="card-gray-color font-medium fs13">Today, 11:00 AM</span>,
      status: <span className="app-status-badge pending">Pending</span>,
      actions: (
        <div className="flex-row gap6">
          <CustomButton text="View" smallBtn whiteBtn onClick={() => {}} />
          <CustomButton text="Approve" smallBtn whiteBtn onClick={() => {}} />
        </div>
      ),
    },
    {
      task: (
        <div>
          <div className="flex-row flex-ali-cen gap8">
            <span className="fs14 font-bold black-color">Perform Blood Test</span>
            <span className="app-priority-badge medium">MEDIUM</span>
          </div>
          <div className="fs12 card-gray-color mt2">
            Complete blood work for scheduled surgery
          </div>
        </div>
      ),
      tags: (
        <div className="wb-card-tags">
          <span className="wb-card-tag monitoring">Monitoring</span>
        </div>
      ),
      assignedTo: (
        <div className="flex-row flex-ali-cen gap8">
          <div className="app-avatar-circle" style={{ width: 28, height: 28, fontSize: 11, backgroundColor: "#10b981" }}>LT</div>
          <span className="fs13 font-semibold black-color">Lab Tech</span>
        </div>
      ),
      dueDate: <span className="red-color font-semibold fs13">1 hour ago</span>,
      status: <span className="app-status-badge rejected">Overdue</span>,
      actions: (
        <div className="flex-row gap6">
          <CustomButton text="View" smallBtn whiteBtn onClick={() => {}} />
          <CustomButton text="Assign" smallBtn whiteBtn onClick={() => {}} />
        </div>
      ),
    },
    {
      task: (
        <div>
          <div className="flex-row flex-ali-cen gap8">
            <span className="fs14 font-bold black-color">Case Summary Review</span>
            <span className="wb-pending-badge">Pending Review</span>
            <span className="app-priority-badge medium">MEDIUM</span>
          </div>
          <div className="fs12 card-gray-color mt2">
            Review and approve case summary for discharge
          </div>
        </div>
      ),
      tags: (
        <div className="wb-card-tags">
          <span className="wb-card-tag">Other</span>
        </div>
      ),
      assignedTo: (
        <div className="flex-row flex-ali-cen gap8">
          <div className="app-avatar-circle" style={{ width: 28, height: 28, fontSize: 11, backgroundColor: "#f59e0b" }}>SV</div>
          <span className="fs13 font-semibold black-color">Supervet</span>
        </div>
      ),
      dueDate: <span className="card-gray-color font-medium fs13">Today, 1:00 PM</span>,
      status: <span className="app-status-badge pending">Pending</span>,
      actions: (
        <div className="flex-row gap6">
          <CustomButton text="View" smallBtn whiteBtn onClick={() => {}} />
          <CustomButton text="Approve" smallBtn whiteBtn onClick={() => {}} />
        </div>
      ),
    },
    {
      task: (
        <div>
          <div className="flex-row flex-ali-cen gap8">
            <span className="fs14 font-bold black-color">Update Medical Records</span>
            <span className="app-priority-badge medium" style={{ backgroundColor: "#d1fae5", color: "#065f46" }}>LOW</span>
          </div>
          <div className="fs12 card-gray-color mt2">
            Update vaccination records for completed appointments
          </div>
        </div>
      ),
      tags: (
        <div className="wb-card-tags">
          <span className="wb-card-tag">Other</span>
        </div>
      ),
      assignedTo: (
        <div className="flex-row flex-ali-cen gap8">
          <div className="app-avatar-circle" style={{ width: 28, height: 28, fontSize: 11 }}>VK</div>
          <span className="fs13 font-semibold black-color">Vivek</span>
        </div>
      ),
      dueDate: <span className="card-gray-color font-medium fs13">Today, 5:00 PM</span>,
      status: <span className="app-status-badge pending">Pending</span>,
      actions: (
        <div className="flex-row gap6">
          <CustomButton text="View" smallBtn whiteBtn onClick={() => {}} />
          <CustomButton text="Complete" smallBtn whiteBtn onClick={() => {}} />
        </div>
      ),
    },
  ];

  return (
    <div className="whiteboard-tab-page">
      {/* Top Controls Bar Card Container - Identical to Calendar screen */}
      <div className="ph15 mh10 mt5">
        <div className="back-white br8brblack p10 mv5">
          <div className="flex-row flex-row-between-align-center flex-wrap gap12">
            {/* Left Controls: Day/Week & Today */}
            <div className="flex-row-ali-cen gap10" style={{ flexShrink: 0 }}>
              <div className="flex-row-ali-cen">
                <div
                  className={`wb-toggle-btn cursor ${
                    activeDayWeek === "day" ? "blue-back-con2" : "day-type-box2 black"
                  }`}
                  onClick={() => setActiveDayWeek("day")}
                >
                  Day
                </div>
                <div
                  className={`wb-toggle-btn cursor ${
                    activeDayWeek === "week" ? "blue-back-con2" : "day-type-box2 black"
                  }`}
                  onClick={() => setActiveDayWeek("week")}
                >
                  Week
                </div>
              </div>
              <div
                className="wb-toggle-btn cursor day-type-box2 black"
                onClick={() => setCurrentDateIndex(0)}
              >
                Today
              </div>
            </div>

            {/* Center Controls: Date Navigation */}
            <div className="flex-center" style={{ flexShrink: 0 }}>
              <div className="flex-row-ali-cen gap8">
                <button type="button" className="wb-date-arrow-btn" onClick={handlePrevDate}>
                  ‹
                </button>
                <div className="wb-date-label-box">
                  {datesList[currentDateIndex]}
                </div>
                <button type="button" className="wb-date-arrow-btn" onClick={handleNextDate}>
                  ›
                </button>
              </div>
            </div>

            {/* Right Controls */}
            <div className="flex-row-ali-cen flex1-end gap10" style={{ flexShrink: 0 }}>
              <div className="flex-row-ali-cen">
                <div
                  className={`wb-toggle-btn cursor ${
                    activeMainTab === "tasks" ? "blue-back-con2" : "day-type-box2 black"
                  }`}
                  onClick={() => setActiveMainTab("tasks")}
                >
                  Tasks
                </div>
                <div
                  className={`wb-toggle-btn cursor ${
                    activeMainTab === "todos" ? "blue-back-con2" : "day-type-box2 black"
                  }`}
                  onClick={() => setActiveMainTab("todos")}
                >
                  To-dos
                </div>
              </div>

              <div className="app-btn-nowrap">
                <CustomButton
                  text="Filter"
                  whiteBtn
                  startIcon={<FilterListIcon sx={{ fontSize: 18 }} />}
                  onClick={() => setIsFilterModalOpen(true)}
                />
              </div>

              {/* Clean Layout Toggle Group for Board / List icons */}
              <div className="wb-layout-toggle-group">
                <button
                  type="button"
                  className={`wb-layout-btn ${activeLayout === "board" ? "active" : ""}`}
                  onClick={() => setActiveLayout("board")}
                  title="Board / Timeline"
                >
                  ▦
                </button>
                <button
                  type="button"
                  className={`wb-layout-btn ${activeLayout === "list" ? "active" : ""}`}
                  onClick={() => setActiveLayout("list")}
                  title="List / Table"
                >
                  ☰
                </button>
              </div>

              <div className="app-btn-nowrap">
                <CustomButton
                  text="Task Guide"
                  whiteBtn
                  startIcon={<MenuBookIcon sx={{ fontSize: 18 }} />}
                  onClick={() => {}}
                />
              </div>

              <div className="app-btn-nowrap">
                <CustomButton
                  text={activeMainTab === "todos" ? "+ New to-do" : "+ New Task"}
                  startIcon={<AddIcon sx={{ fontSize: 18 }} />}
                  onClick={() => {
                    if (activeMainTab === "todos") setIsTodoModalOpen(true);
                    else handleOpenTaskModal();
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Sub-bar: Me / Team Toggle (Tasks view) */}
      {activeMainTab === "tasks" && (
        <div className="wb-me-team-bar ph15 mh10">
          <div className="flex-row-ali-cen">
            <div
              className={`wb-toggle-btn cursor ${
                activeMeTeam === "my" ? "blue-back-con2" : "day-type-box2 black"
              }`}
              onClick={() => setActiveMeTeam("my")}
            >
              <PersonIcon sx={{ fontSize: 16, mr: 0.5 }} /> Me
            </div>
            <div
              className={`wb-toggle-btn cursor ${
                activeMeTeam === "team" ? "blue-back-con2" : "day-type-box2 black"
              }`}
              onClick={() => setActiveMeTeam("team")}
            >
              <GroupsIcon sx={{ fontSize: 16, mr: 0.5 }} /> Team
            </div>
          </div>
        </div>
      )}

      {/* Content Section: Tasks Board View */}
      {activeMainTab === "tasks" && activeLayout === "board" && (
        <div className="wb-grid-container">
          <table className="wb-table">
            <thead>
              <tr>
                <th className="wb-time-col">Time</th>
                <th>
                  <div className="wb-table-header-name">Vivek</div>
                  <div className="wb-table-header-sub">Veterinarian</div>
                  <div className="wb-table-header-count">2 Tasks</div>
                </th>
                <th>
                  <div className="wb-table-header-name">Supervet</div>
                  <div className="wb-table-header-sub">Senior Vet</div>
                  <div className="wb-table-header-count">1 Task</div>
                </th>
                <th>
                  <div className="wb-table-header-name">Lab Tech</div>
                  <div className="wb-table-header-sub">Technician</div>
                  <div className="wb-table-header-count">1 Task</div>
                </th>
                <th>
                  <div className="wb-table-header-name">Unassigned</div>
                  <div className="wb-table-header-sub">Unassigned Tasks</div>
                  <div className="wb-table-header-count">2 Tasks</div>
                </th>
              </tr>
            </thead>
            <tbody>
              {/* 09:00 Slot */}
              <tr>
                <td className="wb-time-col">09:00</td>
                <td>
                  <div className="wb-task-card priority-high">
                    <div className="wb-card-title">Review X-ray Results</div>
                    <div className="wb-card-tags">
                      <span className="wb-card-tag monitoring">Monitoring</span>
                      <span className="wb-card-tag outpatient">Outpatient</span>
                    </div>
                    <div className="wb-card-due overdue">Due: 2h ago</div>
                  </div>
                </td>
                <td />
                <td>
                  <div className="wb-task-card priority-medium">
                    <div className="wb-card-title">Perform Blood Test</div>
                    <div className="wb-card-tags">
                      <span className="wb-card-tag monitoring">Monitoring</span>
                    </div>
                    <div className="wb-card-due overdue">Due: 1h ago</div>
                  </div>
                </td>
                <td>
                  <div className="wb-task-card priority-medium">
                    <div className="wb-card-title">Follow-up Call</div>
                    <div className="wb-card-tags">
                      <span className="wb-card-tag unassigned">Unassigned</span>
                    </div>
                    <div className="wb-card-due">Due: Today, 2:00 PM</div>
                  </div>
                </td>
              </tr>

              {/* 10:00 Slot */}
              <tr>
                <td className="wb-time-col">10:00</td>
                <td>
                  <div className="wb-task-card priority-urgent">
                    <div className="wb-card-title">Review Diagnostic Report ⚠️</div>
                    <div className="wb-card-tags">
                      <span className="wb-card-tag inpatient">Inpatient</span>
                      <span className="wb-card-tag plan-source">📋 Plan</span>
                    </div>
                    <span className="wb-pending-badge">Pending Review</span>
                    <div className="wb-card-due">Due: Today, 11:00 AM</div>
                  </div>
                </td>
                <td />
                <td />
                <td>
                  <div className="wb-task-card priority-medium">
                    <div className="wb-card-title">Schedule Follow-up</div>
                    <div className="wb-card-due">Due: Wed, Feb 14</div>
                  </div>
                </td>
              </tr>

              {/* 11:00 Slot */}
              <tr>
                <td className="wb-time-col">11:00</td>
                <td>
                  <div className="wb-task-card priority-high">
                    <div className="wb-card-title">Daily Progress Notes</div>
                    <div className="wb-card-tags">
                      <span className="wb-card-tag inpatient">Inpatient</span>
                      <span className="wb-card-tag plan-source">📋 Plan</span>
                    </div>
                    <span className="wb-pending-badge">Pending Review</span>
                    <div className="wb-card-due">Due: Today, 12:00 PM</div>
                  </div>
                </td>
                <td>
                  <div className="wb-task-card priority-medium">
                    <div className="wb-card-title">Case Summary Review</div>
                    <span className="wb-pending-badge">Pending Review</span>
                    <div className="wb-card-due">Due: Today, 1:00 PM</div>
                  </div>
                </td>
                <td />
                <td />
              </tr>

              {/* 12:00 Slot */}
              <tr>
                <td className="wb-time-col">12:00</td>
                <td />
                <td />
                <td />
                <td>
                  <div className="wb-task-card priority-low">
                    <div className="wb-card-title">Update Medical Records</div>
                    <div className="wb-card-due">Due: Today, 5:00 PM</div>
                  </div>
                </td>
              </tr>

              {/* 14:00 Slot */}
              <tr>
                <td className="wb-time-col">14:00</td>
                <td>
                  <div className="wb-task-card priority-urgent">
                    <div className="wb-card-title">Compliance Issue ⚠️</div>
                    <div className="wb-card-tags">
                      <span className="wb-card-tag inpatient">Inpatient</span>
                      <span className="wb-card-tag plan-source">📋 Plan</span>
                    </div>
                    <div className="wb-card-due overdue">Due: Now</div>
                  </div>
                </td>
                <td />
                <td />
                <td />
              </tr>
            </tbody>
          </table>
        </div>
      )}

      {/* Content Section: Tasks List View */}
      {activeMainTab === "tasks" && activeLayout === "list" && (
        <ReportTable columns={listColumns} datas={listDatas} maxHeight="none" />
      )}

      {/* Content Section: Personal To-Dos View */}
      {activeMainTab === "todos" && (
        <div className="wb-todos-container">
          <Typography className="fs14 font-bold card-gray-color uppercase tracking-wider">
            Personal notes and to-dos
          </Typography>
          <div className="wb-sticky-board">
            {stickyNotes.map((note) => (
              <div className={`wb-sticky-note color-${note.color}`} key={note.id}>
                <div>
                  <div className="wb-note-title">{note.title}</div>
                  <div className="wb-note-body">{note.content}</div>
                </div>
                <div className="wb-note-footer">
                  <span>Due: {note.dueDate}</span>
                  <span className={`app-priority-badge ${note.priority.toLowerCase()}`}>
                    {note.priority}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Create Task Custom Drawer Modal - Expandable Multi-Task Accordion */}
      <CustomModal
        open={isTaskModalOpen}
        onClose={() => setIsTaskModalOpen(false)}
        header="Create Task"
        rightModal
        modalWidth={40}
        headerBold
      >
        <Grid container spacing={2} className="ph20 scroll-80vh pt10">
          {/* Patient Type Selector */}
          <Grid item xs={12}>
            <div className="patient-type-toggle-bar">
              <CustomButton
                text="Inpatient"
                tabSelectdBtn={patientType === "inpatient"}
                textBtn={patientType !== "inpatient"}
                onClick={() => setPatientType("inpatient")}
              />
              <CustomButton
                text="Outpatient"
                tabSelectdBtn={patientType === "outpatient"}
                textBtn={patientType !== "outpatient"}
                onClick={() => setPatientType("outpatient")}
              />
            </div>
            <Typography className="fs11 card-gray-color italic mt8">
              Each task below is an order added to this patient's Treatment Plan — the same order drives what shows on the Whiteboard schedule and, once marked given, what lands in the Patient Workbook.
            </Typography>
          </Grid>

          {/* Expandable Multi-Task List */}
          <Grid item xs={12}>
            <div className="ct-tasks-container">
              {createTaskList.map((taskItem, index) => {
                const taskNum = index + 1;
                const isExp = taskItem.isExpanded;
                const currentType = taskItem.type || "Medication";

                const getFieldLabel = () => {
                  if (currentType === "Monitoring Check") return "PARAMETER / CHECK NAME";
                  if (currentType === "Procedure") return "PROCEDURE NAME";
                  if (currentType === "Diet") return "DIET / FOOD TYPE";
                  if (currentType === "Fluid Therapy") return "FLUID TYPE";
                  if (currentType === "Other") return "TASK NAME";
                  return "DRUG NAME";
                };

                const getFieldPlaceholder = () => {
                  if (currentType === "Monitoring Check") return "e.g. TPR check, Blood glucose check";
                  if (currentType === "Procedure") return "e.g. Wound dressing change";
                  if (currentType === "Diet") return "e.g. Prescription GI Diet (can)";
                  if (currentType === "Fluid Therapy") return "e.g. LRS IV Fluid";
                  if (currentType === "Other") return "e.g. Schedule follow-up call";
                  return "e.g. Amoxicillin Inj.";
                };

                const showDose = currentType === "Medication" || currentType === "Fluid Therapy" || currentType === "Diet";
                const showRoute = currentType === "Medication" || currentType === "Fluid Therapy";

                return (
                  <div className={`ct-task-item ${isExp ? "active" : ""}`} key={taskItem.id}>
                    {/* Collapsed / Summary Header */}
                    <div
                      className={`ct-task-header ${!isExp ? "collapsed" : ""}`}
                      onClick={() => toggleTaskAccordion(taskItem.id)}
                    >
                      <div className="flex-row flex-ali-cen gap12">
                        <span className="ct-task-number">Task {taskNum}</span>
                        <div>
                          <div className="ct-task-title">{taskItem.name || "New Task"}</div>
                          <div className="ct-task-subtext">
                            Type: {currentType} · Priority: {taskItem.priority} · Schedule: {taskItem.frequency || "Once"}
                          </div>
                        </div>
                      </div>

                      <div className="flex-row flex-ali-cen gap10">
                        <span className="fs14 card-gray-color">{isExp ? "▼" : "►"}</span>
                        {createTaskList.length > 1 && (
                          <button
                            type="button"
                            className="ct-task-remove-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleRemoveTask(taskItem.id);
                            }}
                          >
                            Remove
                          </button>
                        )}
                      </div>
                    </div>

                    {/* Form Fields (when expanded) */}
                    {isExp && (
                      <Grid container spacing={2} className="ph15 pb15 pt10" style={{ borderTop: "1px solid #e5e7eb" }}>
                        <Grid item xs={6}>
                          <div className="txt-semi-bold fs12 card-gray-color uppercase mb5">
                            TYPE <span className="red-color">*</span>
                          </div>
                          <Select
                            list={taskTypeOptions}
                            value={taskItem.type}
                            handleChange={(e) => updateTaskField(taskItem.id, "type", e?.target?.value)}
                            select
                          />
                        </Grid>

                        <Grid item xs={6}>
                          <div className="txt-semi-bold fs12 card-gray-color uppercase mb5">PRIORITY</div>
                          <Select
                            list={priorityOptions}
                            value={taskItem.priority}
                            handleChange={(e) => updateTaskField(taskItem.id, "priority", e?.target?.value)}
                            select
                          />
                        </Grid>

                        <Grid item xs={12}>
                          <div className="txt-semi-bold fs12 card-gray-color uppercase mb5">
                            {getFieldLabel()} <span className="red-color">*</span>
                          </div>
                          <CustomTextField
                            placeholder={getFieldPlaceholder()}
                            fullWidth
                            value={taskItem.name}
                            handleChange={(e) => updateTaskField(taskItem.id, "name", e?.target?.value)}
                          />
                          <Typography className="fs10 card-gray-color italic mt3">
                            Picking a name from the list links this order to the inventory master — that's what lets it bill and tag correctly once given.
                          </Typography>
                        </Grid>

                        {showDose && (
                          <Grid item xs={showRoute ? 6 : 12}>
                            <div className="txt-semi-bold fs12 card-gray-color uppercase mb5">
                              {currentType === "Diet" ? "AMOUNT PER FEEDING" : currentType === "Fluid Therapy" ? "RATE" : "DOSE"}
                            </div>
                            <CustomTextField
                              placeholder={currentType === "Diet" ? "e.g. 1 can" : currentType === "Fluid Therapy" ? "e.g. 40 ml/hr" : "e.g. 15 mg/kg"}
                              fullWidth
                              value={taskItem.dose}
                              handleChange={(e) => updateTaskField(taskItem.id, "dose", e?.target?.value)}
                            />
                          </Grid>
                        )}

                        {showRoute && (
                          <Grid item xs={6}>
                            <div className="txt-semi-bold fs12 card-gray-color uppercase mb5">ROUTE</div>
                            <Select
                              list={routeOptions}
                              value={taskItem.route}
                              handleChange={(e) => updateTaskField(taskItem.id, "route", e?.target?.value)}
                              select
                            />
                          </Grid>
                        )}

                        {patientType === "inpatient" && (
                          <>
                            <Grid item xs={6}>
                              <div className="txt-semi-bold fs12 card-gray-color uppercase mb5">FREQUENCY</div>
                              <Select
                                list={frequencyOptions}
                                value={taskItem.frequency}
                                handleChange={(e) => updateTaskField(taskItem.id, "frequency", e?.target?.value)}
                                select
                              />
                            </Grid>

                            <Grid item xs={6}>
                              <div className="txt-semi-bold fs12 card-gray-color uppercase mb5">START</div>
                              <CustomTextField
                                type="datetime-local"
                                fullWidth
                                value={taskItem.start}
                                handleChange={(e) => updateTaskField(taskItem.id, "start", e?.target?.value)}
                              />
                            </Grid>

                            <Grid item xs={12}>
                              <div className="txt-semi-bold fs12 card-gray-color uppercase mb5">DURATION</div>
                              <Select
                                list={durationOptions}
                                value={taskItem.duration}
                                handleChange={(e) => updateTaskField(taskItem.id, "duration", e?.target?.value)}
                                select
                              />
                            </Grid>
                          </>
                        )}

                        <Grid item xs={12}>
                          <div className="txt-semi-bold fs12 card-gray-color uppercase mb5">ASSIGN TO</div>
                          <Select
                            list={assignOptions}
                            value={taskItem.assignTo}
                            handleChange={(e) => updateTaskField(taskItem.id, "assignTo", e?.target?.value)}
                            select
                          />
                          <Typography className="fs10 card-gray-color italic mt3">
                            Auto-assignment will be based on role, availability, and workload (coming soon)
                          </Typography>
                        </Grid>

                        <Grid item xs={12}>
                          <div className="txt-semi-bold fs12 card-gray-color uppercase mb5">NOTES</div>
                          <CustomTextField
                            placeholder="Optional"
                            fullWidth
                            multiline
                            rows={2}
                            value={taskItem.notes}
                            handleChange={(e) => updateTaskField(taskItem.id, "notes", e?.target?.value)}
                          />
                        </Grid>
                      </Grid>
                    )}
                  </div>
                );
              })}

              {/* Add Another Task Button */}
              <button type="button" className="ct-add-task-btn" onClick={handleAddNewTask}>
                + Add Another Task
              </button>
            </div>
          </Grid>

          {/* Modal Footer Buttons */}
          <Grid item xs={12} className="flex-row flex1-end gap12 mt20 mb20">
            <CustomButton text="Cancel" grayBtn onClick={() => setIsTaskModalOpen(false)} />
            <CustomButton text="Save" onClick={handleSaveAllTasks} />
          </Grid>
        </Grid>
      </CustomModal>

      {/* New Note / To-do Custom Drawer Modal */}
      <CustomModal
        open={isTodoModalOpen}
        onClose={() => setIsTodoModalOpen(false)}
        header="New Note"
        rightModal
        modalWidth={30}
        headerBold
      >
        <Grid container spacing={2} className="ph20 scroll-80vh pt10">
          <Grid item xs={12}>
            <div className="txt-semi-bold fs14 light-grey mb5">Title</div>
            <CustomTextField
              placeholder="Enter note title..."
              fullWidth
              value={todoForm.title}
              handleChange={(e) => setTodoForm({ ...todoForm, title: e?.target?.value })}
            />
          </Grid>

          <Grid item xs={12}>
            <div className="txt-semi-bold fs14 light-grey mb5">Content</div>
            <CustomTextField
              placeholder="Write your note here..."
              fullWidth
              multiline
              rows={3}
              value={todoForm.content}
              handleChange={(e) => setTodoForm({ ...todoForm, content: e?.target?.value })}
            />
          </Grid>

          <Grid item xs={12}>
            <div className="txt-semi-bold fs14 light-grey mb5">Priority</div>
            <Select
              list={priorityOptions}
              value={todoForm.priority}
              handleChange={(e) => setTodoForm({ ...todoForm, priority: e?.target?.value })}
              select
            />
          </Grid>

          <Grid item xs={12}>
            <div className="txt-semi-bold fs14 light-grey mb5">Note Color</div>
            <div className="color-picker-row">
              <div
                className={`color-option-circle color-yellow ${
                  todoForm.color === "yellow" ? "selected" : ""
                }`}
                style={{ backgroundColor: "#fef3c7" }}
                onClick={() => setTodoForm({ ...todoForm, color: "yellow" })}
              />
              <div
                className={`color-option-circle color-blue ${
                  todoForm.color === "blue" ? "selected" : ""
                }`}
                style={{ backgroundColor: "#dbeafe" }}
                onClick={() => setTodoForm({ ...todoForm, color: "blue" })}
              />
              <div
                className={`color-option-circle color-green ${
                  todoForm.color === "green" ? "selected" : ""
                }`}
                style={{ backgroundColor: "#d1fae5" }}
                onClick={() => setTodoForm({ ...todoForm, color: "green" })}
              />
            </div>
          </Grid>

          <Grid item xs={12} className="flex-row flex1-end gap12 mt20 mb20">
            <CustomButton text="Cancel" grayBtn onClick={() => setIsTodoModalOpen(false)} />
            <CustomButton text="Save Note" onClick={handleCreateTodoSubmit} />
          </Grid>
        </Grid>
      </CustomModal>

      {/* Filter Custom Side Drawer Modal */}
      <CustomModal
        open={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        header="Filter"
        rightModal
        modalWidth="28"
        headerBold
      >
        <Grid container spacing={2} className="ph20 scroll-80vh pt10">
          {/* 1. DISPLAY SETTINGS */}
          <Grid item xs={12}>
            <div
              className="flex-row flex-row-between-align-center cursor mb10"
              onClick={() => setFilterDisplayViewSection(!filterDisplayViewSection)}
            >
              <div className="txt-semi-bold fs12 card-gray-color uppercase">
                DISPLAY SETTINGS
              </div>
              <span className="fs12 card-gray-color">
                {filterDisplayViewSection ? "▼" : "►"}
              </span>
            </div>
            {filterDisplayViewSection && (
              <div className="flex-col gap10 pl5">
                <CustomCheckbox
                  label="Show unassigned tasks"
                  checked={showUnassignedTasks}
                  onChange={() => setShowUnassignedTasks(!showUnassignedTasks)}
                />
                <CustomCheckbox
                  label="Show compliance issues"
                  checked={showComplianceIssues}
                  onChange={() => setShowComplianceIssues(!showComplianceIssues)}
                />
              </div>
            )}
          </Grid>

          {/* 2. APPOINTMENT TYPE */}
          <Grid item xs={12}>
            <div className="txt-semi-bold fs12 card-gray-color uppercase mb5">
              APPOINTMENT TYPE
            </div>
            <Select
              list={filterApptTypeOptions}
              value={filterApptType}
              handleChange={(e) => setFilterApptType(e?.target?.value)}
              select
            />
          </Grid>

          {/* 3. TASK TYPE */}
          <Grid item xs={12}>
            <div className="txt-semi-bold fs12 card-gray-color uppercase mb5">
              TASK TYPE
            </div>
            <Select
              list={filterTaskTypeOptions}
              value={filterTaskType}
              handleChange={(e) => setFilterTaskType(e?.target?.value)}
              select
            />
          </Grid>

          {/* 4. STATUS */}
          <Grid item xs={12}>
            <div className="txt-semi-bold fs12 card-gray-color uppercase mb5">
              STATUS
            </div>
            <Select
              list={filterStatusOptions}
              value={filterStatus}
              handleChange={(e) => setFilterStatus(e?.target?.value)}
              select
            />
          </Grid>

          {/* 5. PRIORITY */}
          <Grid item xs={12}>
            <div className="txt-semi-bold fs12 card-gray-color uppercase mb5">
              PRIORITY
            </div>
            <Select
              list={filterPriorityOptions}
              value={filterPriority}
              handleChange={(e) => setFilterPriority(e?.target?.value)}
              select
            />
          </Grid>

          {/* Bottom Action Buttons */}
          <Grid item xs={12} className="flex-row flex1-end gap12 mt20 mb20">
            <CustomButton
              text="Reset All"
              whiteBtn
              onClick={handleResetFilters}
            />
            <CustomButton
              text="Apply Filters"
              onClick={handleApplyFilters}
            />
          </Grid>
        </Grid>
      </CustomModal>
    </div>
  );
};

export default WhiteboardTab;
